import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TCreateFinixCardRequest } from "./createFinixCard.schema";

export const createFinixCard =
  (axios: IAxiosInstance) => async (params: TCreateFinixCardRequest) => {
    const response = await axios.noRetry.post(
      "/api/business-cards/finix-card",
      params
    );
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Error creating Finix card");
  };
